import React from "react";
import Spreadsheet from "x-data-spreadsheet";
import "x-data-spreadsheet/dist/xspreadsheet.css";

export default function SpreadsheetEditor({ data, setData }) {
  const sheetEl = React.useRef(null);
  const sheetRef = React.useRef(null);

  React.useEffect(() => {
    const element = sheetEl.current;
    if (!element) return;

    const sheet = new Spreadsheet("#x-spreadsheet-demo", {
      view: {
        height: () => element.clientHeight || document.documentElement.clientHeight,
        width: () => element.clientWidth || document.documentElement.clientWidth,
      },
      mode: "edit",
      showToolbar: true,
      showGrid: true,
      showBottomBar: true,
      showContextmenu: true,
    })
      .loadData(data)
      .change((updatedData) => {
        setData(updatedData);
      });

    sheetRef.current = sheet;

    return () => {
      if (element) {
        element.innerHTML = "";
      }
    };
  }, [data]);

  return <div ref={sheetEl} style={{ height: "800px", width: "100%" }} id="x-spreadsheet-demo" className="my-2"></div>;
}
